import { ChangeDetectionStrategy, Component, HostBinding, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { COMMON_CLIENT_CONFIG } from '~ng-common-lib/core/tokens/client-config';
import { LottieAnimationComponent } from '~ng-common-lib/ui/animations/lottie-animation.component';

@Component({
	selector: 'reach-logo-loader',
	templateUrl: './logo.html',
	styleUrls: ['./logo.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [CommonModule, LottieAnimationComponent],
})
export class ReachLogoLoaderComponent {
	private readonly clientConfig = inject(COMMON_CLIENT_CONFIG);

	@HostBinding('class.animating')
	@Input()
	public spinning = true;

	@HostBinding('class.white')
	@Input()
	public white = false;

	public readonly useLottieAnimation = this.clientConfig.branding.loader.logoVariant === 'lottie';
	public readonly lottiePath =
		this.clientConfig.branding.loader.logoLottiePath ?? '/assets/animations/ioc_animation.json';
}
